





















































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

import UiFormLabel from '../ui/UiFormLabel.vue';
import UiRadioGroup from '../ui/UiRadioGroup.vue';
import UiSelect from '../ui/UiSelect.vue';
import UiSelect2 from '../ui/UiSelect2.vue';
import {
  buildLabelInclusionRule,
  buildLabelRuleOptions,
  LabelRuleOption,
  TEMPLATE_OPTION_ID_PREFIX,
} from './helpers/labelRules';

type LabelDef = { labelId?: string; name?: string; enabled?: boolean; isDeleted?: boolean };

/**
 * Self-contained "Transaction Inclusion" picker. Emits `input` with the
 * resulting labelInclusionRule (or undefined for include-all) whenever the
 * mode/combinator/selection changes. Vue 2 counterpart of web-app-v3's
 * LabelRulesSection — kept as its own component so the interactivity is
 * mountable and unit-testable in isolation.
 */
@Component({ components: { UiFormLabel, UiRadioGroup, UiSelect, UiSelect2 } })
export default class InventoryViewLabelRules extends Vue {
  @Prop({ default: () => [] })
  public readonly labelDefinitions!: LabelDef[];

  public mode: 'all' | 'include' | 'exclude' = 'all';
  public match: 'any' | 'all' = 'all';
  public selectedIds: string[] = [];

  public modeOptions = [
    { label: 'Include all transactions', value: 'all' },
    { label: 'Include only transactions matching label rules', value: 'include' },
    { label: 'Exclude transactions matching label rules', value: 'exclude' },
  ];

  public matchOptions = [
    { label: 'any', value: 'any' },
    { label: 'all', value: 'all' },
  ];

  get options(): LabelRuleOption[] {
    return buildLabelRuleOptions(this.labelDefinitions);
  }

  get hasTemplateSelected(): boolean {
    return this.selectedIds.some((id) => id.startsWith(TEMPLATE_OPTION_ID_PREFIX));
  }

  get exampleTemplate(): string {
    const templateId = this.selectedIds.find((id) => id.startsWith(TEMPLATE_OPTION_ID_PREFIX));
    return templateId ? templateId.slice(TEMPLATE_OPTION_ID_PREFIX.length) : 'client';
  }

  @Watch('mode')
  @Watch('match')
  @Watch('selectedIds')
  emitRule() {
    this.$emit('input', buildLabelInclusionRule(this.mode, this.match, this.selectedIds, this.options));
  }
}
